import React from 'react';
import { useForm } from 'react-hook-form';
import { Marketing } from '../../utils/formNames';
import { getFormData } from '../../utils/sessionStorage';
import { FORM_HOST } from '../../utils/constants';
import EnrollmentForm from './EnrollmentForm';
import EnrollmentFormTextArea from '../FormInputs/FormTextArea';
import EnrollmentFormError from '../FormInputs/FormError';

const formName = Marketing;
const pardotFormUrl = `${FORM_HOST}/l/772833/2020-04-14/5c6ztx`;
const callbackLocations = {
  success_location: `${FORM_HOST}/l/772833/2020-07-06/7k97qq/772833/58631/marketing_success.js`,
  error_location: `${FORM_HOST}/l/772833/2020-07-06/7k97qn/772833/58629/marketing_error.js`,
};

const MarketingForm = () => {
  const { register, handleSubmit, formState, errors } = useForm({
    mode: 'onBlur',
    submitFocusError: false,
  });

  const previousData = getFormData(formName);

  return (
    <EnrollmentForm
      formName={formName}
      callbackLocations={callbackLocations}
      actionUrl={pardotFormUrl}
      formValid={formState.isValid}
      validationHandler={handleSubmit}
    >
      <legend>Marketing</legend>
      <EnrollmentFormTextArea
        name="marketing_experience"
        label="Please list any relevant marketing experiences projects, certifications, coursework, or skills."
        defaultValue={previousData.marketing_experience}
        inputRef={register({ maxLength: 5000 })}
        error={errors.marketing_experience}
      />
      <EnrollmentFormError errorField={errors.marketing_experience} />
    </EnrollmentForm>
  );
};

export default MarketingForm;
